import React, { useEffect, useState } from "react";

const CountdownPopup = ({ media, onSave, onClose }) => {

    const [name, setName] = useState("");
    const [targetDate, setTargetDate] = useState("");
    const [message, setMessage] = useState("");
    const [expiredMessage, setExpiredMessage] = useState("Event Started");
    const [showDaysOnly, setShowDaysOnly] = useState(false);
    const [duration, setDuration] = useState(30);

    useEffect(() => {

        if (media) {
            setName(media.name);
            setTargetDate(media.targetDate || "");
            setMessage(media.message || "");
            setExpiredMessage(media.expiredMessage || "Event Started");
            setShowDaysOnly(media.showDaysOnly || false);
            setDuration(media.duration || 30);
        }

    }, [media]);

    const handleSave = () => {

        onSave({
            id: media?.id || null,
            name,
            targetDate,
            message,
            expiredMessage,
            showDaysOnly,
            duration
        });

    };

    return (

        <div className="popup-overlay">

            <div className="popup-content" style={{ width: 600 }}>

                <h2>{media ? "Edit Countdown" : "Add Countdown"}</h2>

                <div className="form-group">
                    <label>Name</label>
                    <input
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Target Date & Time</label>

                    <input
                        type="datetime-local"
                        className="form-control"
                        value={targetDate}
                        onChange={(e) => setTargetDate(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Display Message</label>

                    <input
                        className="form-control"
                        placeholder="Time Remaining"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Expired Message</label>

                    <input
                        className="form-control"
                        value={expiredMessage}
                        onChange={(e) => setExpiredMessage(e.target.value)}
                    />
                </div>

                <div className="form-group">

                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={showDaysOnly}
                            onChange={(e) => setShowDaysOnly(e.target.checked)}
                        />

                        <label className="form-check-label">
                            Show Days Only
                        </label>
                    </div>

                </div>

                <div className="form-group">
                    <label>Widget Duration (seconds)</label>

                    <input
                        type="number"
                        className="form-control"
                        value={duration}
                        onChange={(e) => setDuration(parseInt(e.target.value))}
                    />
                </div>

                <div className="form-buttons">
                    <button className="btn btn-success" onClick={handleSave}>
                        Save
                    </button>

                    &nbsp;

                    <button className="btn btn-primary" onClick={onClose}>
                        Cancel
                    </button>
                </div>

            </div>

        </div>

    );
};

export default CountdownPopup;